import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { ftpSettings as getFtpSettings } from '../utils/urls';

import { FTPSettings } from 'types/ftpSettings';
import { ErrorModal } from 'types/modalTypes';

async function fetchFtpSettings({ accountId }: TVariables): Promise<APIResult> {
  const response = await fetch(getFtpSettings(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  Data: FTPSettings | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TResult = FTPSettings;

type TVariables = {
  accountId: number;
};

function useGetFtpSettings(accountId: number): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_ftp_settings', accountId],
    async () => {
      let fetchResponse;
      if (accountId) {
        fetchResponse = await fetchFtpSettings({
          accountId,
        });
      }
      return fetchResponse?.Data;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetFtpSettings };
